/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Direction_Haben5Inputs */



/**

* @param {_Field__Enum_Direction_Haben5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_direction_haben5 = /** @type {((inputs?: _Field__Enum_Direction_Haben5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Direction_Haben5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Haben")
});
export { _field__enum_direction_haben5 as "_field__enum_direction_HABEN" }